import { injectIntl } from 'react-intl';

import { CONVERSATIONAL_SALES_VIDEO_AND_ARTICLE } from 'constants/pixels';

import { ReactComponent as ConnectionIcon } from 'assets/bosta-icons/connectionIcon.svg';
import { ReactComponent as InstagramIcon } from 'assets/bosta-icons/instagramColored.svg';
import { ReactComponent as FaceBookIcon } from 'assets/bosta-icons/facebook-shop.svg';

import './InstagramSectionTwo.less';

const InstagramSectionTwo = ({ intl }) => {
  const { formatMessage } = intl;

  return (
    <div className="br-instagram-section-two__body-container">
      <div className="br-instagram-section-two__icons-section">
        <FaceBookIcon />
        <ConnectionIcon className="br-instagram-section-two__repeat-icon" />
        <InstagramIcon />
      </div>
      <div className="br-instagram-section-two__description body-medium">
        <span>
          {formatMessage({
            id: 'chats_plugins.install_plugins.connect_instagram_account'
          })}
        </span>
      </div>
      <div className="br-instagram-section-two__steps">
        <div className="br-instagram-section-two__steps__title text-gray">
          {formatMessage(
            {
              id: 'chats_plugins.install_plugins.instagram_page_setting'
            },
            {
              span: (children) => <span>{children}</span>
            }
          )}
        </div>
        <div className="br-instagram-section-two__steps__title-next text-gray">
          {formatMessage(
            {
              id: 'chats_plugins.install_plugins.instagram_page_setting_next'
            },
            {
              span: (children) => <span>{children}</span>
            }
          )}
        </div>

        <div className="br-instagram-section-two__connection-steps-connect-fb">
          {formatMessage(
            {
              id: 'chats_plugins.install_plugins.connect_facebook_page'
            },
            {
              span: (children) => (
                <a
                  href={
                    CONVERSATIONAL_SALES_VIDEO_AND_ARTICLE.INSTAGRAM
                      .CONNECT_FB_PAGE[intl.locale]
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  {children}
                </a>
              )
            }
          )}
        </div>
      </div>
    </div>
  );
};

export default injectIntl(InstagramSectionTwo);
